/*
    BEEP BOP BOOP - I AM AN AUTO GENERATED FILE - DO NOT EDIT ME MANUALLY
*/


// Name: Messaging JSON Schemas 

const _EMAIL_EVENT_JSON_SCHEMA = {
    "$ref": "#/definitions/EmailEventSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "EmailEventSchema": {
            "additionalProperties": false,
            "properties": {
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "email_uid": {
                    "reference_type": "uuid",
                    "title": "Email Uid",
                    "type": "string",
                    "uid_resource_type": "sent_email"
                },
                "event_type": {
                    "class_name": "MailgunEventType",
                    "enum": [
                        "accepted",
                        "rejected",
                        "delivered",
                        "failed",
                        "opened",
                        "clicked",
                        "unsubscribed",
                        "complained",
                        "stored"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "event_uid": {
                    "reference_type": "uuid",
                    "title": "Event Uid",
                    "type": "string",
                    "uid_resource_type": "email_event"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "mailgun_email_id": {
                    "title": "Mailgun Email Id",
                    "type": "string"
                }
            },
            "required": [
                "created_timestamp",
                "email_uid",
                "event_type",
                "event_uid",
                "last_updated_timestamp",
                "mailgun_email_id"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _EMAIL_TEMPLATE_JSON_SCHEMA = {
    "$ref": "#/definitions/EmailTemplateSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "EmailTemplateSchema": {
            "additionalProperties": false,
            "properties": {
                "archived": {
                    "title": "Archived",
                    "type": "boolean"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "email_body": {
                    "title": "Email Body",
                    "type": "string"
                },
                "email_subject": {
                    "title": "Email Subject",
                    "type": "string"
                },
                "internal_name": {
                    "title": "Internal Name",
                    "type": "string"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "template_id": {
                    "format": "integer",
                    "title": "Template Id",
                    "type": "number"
                },
                "template_uid": {
                    "reference_type": "uuid",
                    "title": "Template Uid",
                    "type": "string",
                    "uid_resource_type": "email_template"
                },
                "template_version": {
                    "format": "integer",
                    "title": "Template Version",
                    "type": "number"
                }
            },
            "required": [
                "archived",
                "created_timestamp",
                "email_body",
                "email_subject",
                "internal_name",
                "last_updated_timestamp",
                "template_id",
                "template_uid",
                "template_version"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _MAILBOX_JSON_SCHEMA = {
    "$ref": "#/definitions/MailboxSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "MailboxSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uids_with_read_permission": {
                    "items": {
                        "title": "account_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Account Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "creating_account_uid": {
                    "reference_type": "uuid",
                    "title": "Creating Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "mailbox_uid": {
                    "reference_type": "uuid",
                    "title": "Mailbox Uid",
                    "type": "string",
                    "uid_resource_type": "mailbox"
                },
                "organization_uids_with_read_permission": {
                    "items": {
                        "title": "organization_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Organization Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "recipient_account_uids": {
                    "items": {
                        "title": "recipient_account_uids",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Recipient Account Uids",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "removed_recipient_account_uids": {
                    "items": {
                        "title": "removed_recipient_account_uids",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Removed Recipient Account Uids",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "resource_type": {
                    "class_name": "ResourceType",
                    "enum": [
                        "unknown_resource_type",
                        "user_account",
                        "user_account_balance",
                        "user_account_balance_source",
                        "user_history_entry",
                        "balance_change_log",
                        "international_user_bank_account",
                        "us_domestic_user_bank_account",
                        "user_bank_account_delta",
                        "user_account_settings",
                        "user_account_admin_ghost",
                        "user_account_finalization",
                        "third_party_user_account_mapping",
                        "previous_email_address",
                        "pending_email_change",
                        "archived_pending_email_change",
                        "password",
                        "expired_password",
                        "password_reset",
                        "deposit",
                        "deposit_invite",
                        "deposit_adjustment",
                        "deposit_interest",
                        "deposit_history_entry",
                        "deposit_close_request",
                        "deposit_user_stats",
                        "deposit_bank_mapping",
                        "deposits_bulk_import",
                        "deposit_interest_log",
                        "archived_deposit_close_request",
                        "deposit_withheld_funds",
                        "pmc_report_timetable",
                        "deposit_group",
                        "deposit_post_close_adjustment",
                        "deposit_user_group",
                        "property_group",
                        "property_user_group",
                        "dispute",
                        "dispute_split",
                        "dispute_intervention_request",
                        "property",
                        "property_address",
                        "compliance",
                        "compliance_rule",
                        "compliance_history",
                        "email_template",
                        "email_verification",
                        "email_verification_record",
                        "email_event",
                        "sent_email",
                        "mailbox",
                        "mailbox_meta_data",
                        "mailbox_message",
                        "permission_entry",
                        "permission_log_entry",
                        "permissions_organization_settings",
                        "resource_permissions",
                        "organization",
                        "organization_resource_permission_rule",
                        "invoice",
                        "invoice_item",
                        "payment_request",
                        "stripe_payment_log",
                        "user_withdraw",
                        "priority_ach_payment",
                        "priority_ach_recurring_payment",
                        "loan_application",
                        "loan_system_info",
                        "loan",
                        "loan_history",
                        "loan_payment_log",
                        "stripe_webhook_log",
                        "user_account_payment_provider_info",
                        "sezzle_order",
                        "sezzle_webhook_event",
                        "bank_account",
                        "bank_account_historical_interest_rate",
                        "bank_account_interest",
                        "bank_account_balance_record",
                        "bank_transfer",
                        "bulk_funds_transfer",
                        "funds_lock",
                        "funds_lock_release_log",
                        "released_funds_lock",
                        "balance_source_transfer",
                        "credit_user_account_log",
                        "event",
                        "event_hook",
                        "notification",
                        "action_item",
                        "update_log_entry",
                        "storage_file",
                        "attached_storage_files",
                        "pre_uploaded_file",
                        "system_history_entry",
                        "snapshot",
                        "ip_address",
                        "known_ip_address",
                        "user_agent",
                        "known_user_agent",
                        "basic_user_account_info",
                        "system_stats",
                        "resource_note",
                        "deposify_tag",
                        "permanent_link",
                        "online_user",
                        "frontend_general_settings",
                        "yardi_screening_works_pro_xml",
                        "yardi_voyager_xml",
                        "yardi_voyager_transaction",
                        "yardi_voyager_resident",
                        "yardi_voyager_resident_custom_column",
                        "yardi_voyager_property_unit",
                        "yardi_voyager_property",
                        "yardi_voyager_pmc_service_interface_version",
                        "yardi_voyager_pmc",
                        "yardi_voyager_pmc_credentials",
                        "yardi_voyager_pet",
                        "yardi_voyager_ils_guest_card_event",
                        "yardi_voyager_charge",
                        "yardi_voyager_charge_code",
                        "yardi_voyager_deposit_create_intent",
                        "yardi_voyager_deposit_close_intent",
                        "yardi_voyager_deposit_withhold_intent",
                        "yardi_voyager_event",
                        "yardi_voyager_flex_deposit_intent",
                        "yardi_voyager_phone",
                        "yardi_voyager_other_occupant",
                        "yardi_voyager_pmc_custom_column_settings",
                        "yardi_voyager_pmc_stats",
                        "yardi_voyager_pmc_stats_collector",
                        "yardi_voyager_active_scan_log_entry",
                        "yardi_voyager_system_settings"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "resource_uid": {
                    "reference_type": "uuid",
                    "title": "Resource Uid",
                    "type": "string"
                }
            },
            "required": [
                "created_timestamp",
                "creating_account_uid",
                "deposify_tags",
                "last_updated_timestamp",
                "mailbox_uid",
                "recipient_account_uids",
                "removed_recipient_account_uids",
                "resource_type",
                "resource_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _MAILBOX_MESSAGE_JSON_SCHEMA = {
    "$ref": "#/definitions/MailboxMessageSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "MailboxMessageSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uids_with_read_permission": {
                    "items": {
                        "title": "account_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Account Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "attached_files_uid": {
                    "reference_type": "uuid",
                    "title": "Attached Files Uid",
                    "type": "string",
                    "uid_resource_type": "attached_storage_files"
                },
                "deleted": {
                    "title": "Deleted",
                    "type": "boolean"
                },
                "deleted_timestamp": {
                    "format": "date-time",
                    "title": "Deleted Timestamp",
                    "type": "string"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "mailbox_uid": {
                    "reference_type": "uuid",
                    "title": "Mailbox Uid",
                    "type": "string",
                    "uid_resource_type": "mailbox"
                },
                "message_body": {
                    "title": "Message Body",
                    "type": "string"
                },
                "message_title": {
                    "title": "Message Title",
                    "type": "string"
                },
                "message_type": {
                    "class_name": "MailboxMessageType",
                    "enum": [
                        "system",
                        "user",
                        "mediator_join"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "message_uid": {
                    "reference_type": "uuid",
                    "title": "Message Uid",
                    "type": "string",
                    "uid_resource_type": "mailbox_message"
                },
                "organization_uids_with_read_permission": {
                    "items": {
                        "title": "organization_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Organization Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "read": {
                    "title": "Read",
                    "type": "boolean"
                },
                "read_timestamp": {
                    "format": "date-time",
                    "title": "Read Timestamp",
                    "type": "string"
                },
                "recipient_account_uid": {
                    "reference_type": "uuid",
                    "title": "Recipient Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "sender_account_uid": {
                    "reference_type": "uuid",
                    "title": "Sender Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "sender_id": {
                    "title": "Sender Id",
                    "type": "string"
                },
                "sent_timestamp": {
                    "format": "date-time",
                    "title": "Sent Timestamp",
                    "type": "string"
                }
            },
            "required": [
                "attached_files_uid",
                "deleted",
                "deleted_timestamp",
                "deposify_tags",
                "last_updated_timestamp",
                "mailbox_uid",
                "message_body",
                "message_title",
                "message_type",
                "message_uid",
                "read",
                "read_timestamp",
                "recipient_account_uid",
                "sender_account_uid",
                "sender_id",
                "sent_timestamp"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _MAILBOX_META_DATA_JSON_SCHEMA = {
    "$ref": "#/definitions/MailboxMetaDataSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "MailboxMetaDataSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uid": {
                    "reference_type": "uuid",
                    "title": "Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "account_uids_with_read_permission": {
                    "items": {
                        "title": "account_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Account Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "mailbox_uid": {
                    "reference_type": "uuid",
                    "title": "Mailbox Uid",
                    "type": "string",
                    "uid_resource_type": "mailbox"
                },
                "meta_data_uid": {
                    "reference_type": "uuid",
                    "title": "Meta Data Uid",
                    "type": "string",
                    "uid_resource_type": "mailbox_meta_data"
                },
                "new_message_count": {
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": -9223372036854775807,
                    "title": "New Message Count",
                    "type": "number"
                },
                "organization_uids_with_read_permission": {
                    "items": {
                        "title": "organization_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Organization Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                }
            },
            "required": [
                "account_uid",
                "created_timestamp",
                "deposify_tags",
                "last_updated_timestamp",
                "mailbox_uid",
                "meta_data_uid",
                "new_message_count"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _SENT_EMAIL_JSON_SCHEMA = {
    "$ref": "#/definitions/SentEmailSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "SentEmailSchema": {
            "additionalProperties": false,
            "properties": {
                "attached_file_names": {
                    "items": {
                        "title": "attached_file_names",
                        "type": "string"
                    },
                    "title": "Attached File Names",
                    "type": "array"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "email_tags": {
                    "items": {
                        "title": "email_tags",
                        "type": "string"
                    },
                    "title": "Email Tags",
                    "type": "array"
                },
                "email_type": {
                    "class_name": "EmailType",
                    "enum": [
                        "verify_email",
                        "email_verified",
                        "finalize_user_account",
                        "security_notice_email",
                        "reset_password",
                        "password_changed",
                        "deposit_invite",
                        "deposit_accepted",
                        "deposit_rejected",
                        "deposit_close_requested",
                        "deposit_close_request_rejected",
                        "deposit_close_request_accepted",
                        "deposit_close_request_cancelled",
                        "deposit_closed",
                        "deposit_cancelled",
                        "deposit_accept_cancelled_by_landlord",
                        "deposit_disputed",
                        "deposit_dispute_split_proposed",
                        "deposit_dispute_split_accepted",
                        "deposit_dispute_split_rejected",
                        "deposit_dispute_split_cancelled",
                        "deposit_dispute_intervention_requested",
                        "deposit_dispute_ended",
                        "deposit_dispute_cancelled",
                        "yardi_screening_works_pro_xml_import",
                        "invoice_paid",
                        "invoice_cancelled",
                        "user_withdraw_created",
                        "user_withdraw_payment_pending",
                        "user_withdraw_completed",
                        "user_withdraw_cancelled",
                        "user_withdraw_edited",
                        "deposit_30_days_remaining",
                        "deposit_payment_cleared",
                        "deposit_receipt_generated",
                        "deposit_admin_stats",
                        "deposit_admin_stats_deltas",
                        "deposit_interest_report",
                        "payment_failure_and_deposit_rollback",
                        "loan_payment_success",
                        "loan_all_payments_complete",
                        "loan_payment_failure",
                        "loan_payment_details_needed",
                        "stats_email"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "email_uid": {
                    "reference_type": "uuid",
                    "title": "Email Uid",
                    "type": "string",
                    "uid_resource_type": "sent_email"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "mailgun_email_id": {
                    "title": "Mailgun Email Id",
                    "type": "string"
                },
                "recipient_account_uid": {
                    "reference_type": "uuid",
                    "title": "Recipient Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "recipient_email_address": {
                    "title": "Recipient Email Address",
                    "type": "string"
                },
                "recipient_email_hash": {
                    "title": "Recipient Email Hash",
                    "type": "string"
                },
                "resource_type": {
                    "class_name": "ResourceType",
                    "enum": [
                        "unknown_resource_type",
                        "user_account",
                        "user_account_balance",
                        "user_account_balance_source",
                        "user_history_entry",
                        "balance_change_log",
                        "international_user_bank_account",
                        "us_domestic_user_bank_account",
                        "user_bank_account_delta",
                        "user_account_settings",
                        "user_account_admin_ghost",
                        "user_account_finalization",
                        "third_party_user_account_mapping",
                        "previous_email_address",
                        "pending_email_change",
                        "archived_pending_email_change",
                        "password",
                        "expired_password",
                        "password_reset",
                        "deposit",
                        "deposit_invite",
                        "deposit_adjustment",
                        "deposit_interest",
                        "deposit_history_entry",
                        "deposit_close_request",
                        "deposit_user_stats",
                        "deposit_bank_mapping",
                        "deposits_bulk_import",
                        "deposit_interest_log",
                        "archived_deposit_close_request",
                        "deposit_withheld_funds",
                        "pmc_report_timetable",
                        "deposit_group",
                        "deposit_post_close_adjustment",
                        "deposit_user_group",
                        "property_group",
                        "property_user_group",
                        "dispute",
                        "dispute_split",
                        "dispute_intervention_request",
                        "property",
                        "property_address",
                        "compliance",
                        "compliance_rule",
                        "compliance_history",
                        "email_template",
                        "email_verification",
                        "email_verification_record",
                        "email_event",
                        "sent_email",
                        "mailbox",
                        "mailbox_meta_data",
                        "mailbox_message",
                        "permission_entry",
                        "permission_log_entry",
                        "permissions_organization_settings",
                        "resource_permissions",
                        "organization",
                        "organization_resource_permission_rule",
                        "invoice",
                        "invoice_item",
                        "payment_request",
                        "stripe_payment_log",
                        "user_withdraw",
                        "priority_ach_payment",
                        "priority_ach_recurring_payment",
                        "loan_application",
                        "loan_system_info",
                        "loan",
                        "loan_history",
                        "loan_payment_log",
                        "stripe_webhook_log",
                        "user_account_payment_provider_info",
                        "sezzle_order",
                        "sezzle_webhook_event",
                        "bank_account",
                        "bank_account_historical_interest_rate",
                        "bank_account_interest",
                        "bank_account_balance_record",
                        "bank_transfer",
                        "bulk_funds_transfer",
                        "funds_lock",
                        "funds_lock_release_log",
                        "released_funds_lock",
                        "balance_source_transfer",
                        "credit_user_account_log",
                        "event",
                        "event_hook",
                        "notification",
                        "action_item",
                        "update_log_entry",
                        "storage_file",
                        "attached_storage_files",
                        "pre_uploaded_file",
                        "system_history_entry",
                        "snapshot",
                        "ip_address",
                        "known_ip_address",
                        "user_agent",
                        "known_user_agent",
                        "basic_user_account_info",
                        "system_stats",
                        "resource_note",
                        "deposify_tag",
                        "permanent_link",
                        "online_user",
                        "frontend_general_settings",
                        "yardi_screening_works_pro_xml",
                        "yardi_voyager_xml",
                        "yardi_voyager_transaction",
                        "yardi_voyager_resident",
                        "yardi_voyager_resident_custom_column",
                        "yardi_voyager_property_unit",
                        "yardi_voyager_property",
                        "yardi_voyager_pmc_service_interface_version",
                        "yardi_voyager_pmc",
                        "yardi_voyager_pmc_credentials",
                        "yardi_voyager_pet",
                        "yardi_voyager_ils_guest_card_event",
                        "yardi_voyager_charge",
                        "yardi_voyager_charge_code",
                        "yardi_voyager_deposit_create_intent",
                        "yardi_voyager_deposit_close_intent",
                        "yardi_voyager_deposit_withhold_intent",
                        "yardi_voyager_event",
                        "yardi_voyager_flex_deposit_intent",
                        "yardi_voyager_phone",
                        "yardi_voyager_other_occupant",
                        "yardi_voyager_pmc_custom_column_settings",
                        "yardi_voyager_pmc_stats",
                        "yardi_voyager_pmc_stats_collector",
                        "yardi_voyager_active_scan_log_entry",
                        "yardi_voyager_system_settings"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "resource_uid": {
                    "reference_type": "uuid",
                    "title": "Resource Uid",
                    "type": "string"
                },
                "template_id": {
                    "format": "integer",
                    "title": "Template Id",
                    "type": "number"
                },
                "template_version": {
                    "format": "integer",
                    "title": "Template Version",
                    "type": "number"
                }
            },
            "required": [
                "attached_file_names",
                "created_timestamp",
                "email_type",
                "email_uid",
                "last_updated_timestamp",
                "mailgun_email_id",
                "recipient_account_uid",
                "recipient_email_address",
                "recipient_email_hash",
                "resource_type",
                "resource_uid",
                "template_id",
                "template_version"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};


export const EMAIL_EVENT_JSON_SCHEMA = _EMAIL_EVENT_JSON_SCHEMA.definitions.EmailEventSchema;
export const EMAIL_TEMPLATE_JSON_SCHEMA = _EMAIL_TEMPLATE_JSON_SCHEMA.definitions.EmailTemplateSchema;
export const MAILBOX_JSON_SCHEMA = _MAILBOX_JSON_SCHEMA.definitions.MailboxSchema;
export const MAILBOX_MESSAGE_JSON_SCHEMA = _MAILBOX_MESSAGE_JSON_SCHEMA.definitions.MailboxMessageSchema;
export const MAILBOX_META_DATA_JSON_SCHEMA = _MAILBOX_META_DATA_JSON_SCHEMA.definitions.MailboxMetaDataSchema;
export const SENT_EMAIL_JSON_SCHEMA = _SENT_EMAIL_JSON_SCHEMA.definitions.SentEmailSchema;
